import { createSlice } from '@reduxjs/toolkit';
import type { TAddress } from 'api/models/TAddress';

type AddressListState = {
  isLoading: boolean;
  errors: null | [];
  data: {
    pageSize?: number;
    totalPages?: number;
    totalItems?: number;
    next?: number | null;
    previous?: number | null;
    addresses?: TAddress[] | null;
  };
};

export const initialState: AddressListState = {
  isLoading: false,
  errors: null,
  data: {}
};

export const slice = createSlice({
  name: 'addressList',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },
    setAddressList: (state, { payload }) => {
      state.data.addresses = payload;
    },
    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    }
  }
});

export const {
  setIsLoading,
  setSuccess,
  setError,
  setInitialState,
  setAddressList
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectAddressListData = (state) => selectSlice(state).data;
export const selectAddressList = (state) =>
  selectAddressListData(state).addresses;
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;

export default slice.reducer;
